
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
    props: {
        modelValue: {
            type: Number,
            required: true,
        },
    },

    emits: {
        "update:modelValue": (payload: number) => typeof payload === "number",
    },

    setup(props, {emit})
    {
        const internalValue = ref(props.modelValue.toString());

        watch(internalValue, (newValue) => {
            emit("update:modelValue", Number.parseFloat(newValue));
        });

        return { internalValue };
    },
})
